// This template requires the Embla Auto Scroll plugin to be installed:
// npm install embla-carousel-auto-scroll

"use client";

import AutoScroll from "embla-carousel-auto-scroll";
// import rainfactoryLogo from '@/assets/public/logos/small/small-rainfactory.png'
import globetrotterLogo from '@/assets/public/logos/small/small-globetrotter.png'
import selfhealixLogo from '@/assets/public/logos/small/small-selfhealix.png'
import operationalaiLogo from '@/assets/public/logos/small/small-operationalai.png'
import apexmodeLogo from '@/assets/public/logos/small/small-apex-mode.png'
import everretireLogo from '@/assets/public/logos/small/small-ever-retire.png'
import cultivatedcupLogo from '@/assets/public/logos/small/small-cultivated-cup.png'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

interface Logo {
  id: string;
  description: string;
  image: string;
  className?: string;
}

interface Logos3Props {
  heading?: string;
  logos?: Logo[];
  className?: string;
}

const Logos3 = ({
  heading = "Trusted and loved by companies around the world",
  logos = [
    {
      id: "logo-4",
      description: "Operational AI",
      image: operationalaiLogo,
      className: "h-5 w-auto",
    },
    {
      id: "logo-1",
      description: "Apex Mode",
      image: apexmodeLogo,
      className: "h-7 w-auto",
    },
    {
      id: "logo-2",
      description: "Globetrotter",
      image: globetrotterLogo,
      className: "h-7 w-auto",
    },
    {
      id: "logo-3",
      description: "Selfhealix",
      image: selfhealixLogo,
      className: "h-7 w-auto",
    },
    {
      id: "logo-7",
      description: "Ever Retire",
      image: everretireLogo,
      className: "h-7 w-auto",
    },
    {
      id: "logo-8",
      description: "Cultivated Cup",
      image: cultivatedcupLogo,
      className: "h-7 w-auto",
    },
  ],
}: Logos3Props) => {
  return (
    <section className="py-16 overflow-hidden">
      <div className="container flex flex-col items-center text-center px-4">
        <h1 className="my-6 text-pretty text-2xl font-bold lg:text-4xl">
          {heading}
        </h1>
      </div>
      <div className="pt-6 md:pt-6 lg:pt-10">
        <div className="relative mx-auto flex items-center justify-center lg:max-w-5xl overflow-hidden">
          <Carousel
            opts={{
              loop: true,
              align: "start",
              containScroll: "trimSnaps"
            }}
            plugins={[
              AutoScroll({
                playOnInit: true,
                stopOnInteraction: false,
                stopOnMouseEnter: true,
                speed: 1
              })
            ]}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {logos.map((logo) => (
                <CarouselItem
                  key={logo.id}
                  className="flex basis-1/3 justify-center pl-4 sm:basis-1/4 md:basis-1/5 lg:basis-1/6"
                >
                  <div className="px-2 sm:px-4 md:px-6 lg:px-8 flex shrink-0 items-center justify-center">
                    <div>
                      <img
                        src={logo.image}
                        alt={logo.description}
                        className={logo.className}
                      />
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-background to-transparent"></div>
          <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent"></div>
        </div>
      </div>
    </section>
  );
};

export { Logos3 }; 